/* Pip & Wells — theme-plus.js: galerij-thumbs voor 3D/video. Laadt na theme.js. */
(function () {
  'use strict';
  // Delivery estimates are rendered in Liquid and remain stable across time zones and weekends.

  /* ---------- Verzendbescherming (cart drawer en cart) ---------- */
  let protectionSyncBusy = false;
  function refreshProtection() {
    // The full cart page needs new server-rendered totals as well as the drawer.
    if (document.querySelector('[data-protection-page]')) {
      window.location.reload();
      return Promise.resolve();
    }
    return PW.refreshCart(false);
  }
  function syncProtection() {
    const box = document.querySelector('[data-protection]'); if (!box || !window.PW) return;
    const variant = parseInt(box.dataset.variant, 10); if (!variant) return;
    const has = box.dataset.has === 'true', others = parseInt(box.dataset.others, 10) || 0;
    let off = false; try { off = localStorage.getItem('pw_sp_off') === '1'; } catch (e) {}
    if (protectionSyncBusy || box.dataset.busy) return;
    if (!has && others > 0 && box.dataset.auto === 'true' && !off) {
      protectionSyncBusy = true; box.dataset.busy = '1';
      PW.addToCart([{ id: variant, quantity: 1 }]).then(refreshProtection).catch(() => {}).finally(() => { protectionSyncBusy = false; delete box.dataset.busy; });
    } else if (has && others === 0 && box.dataset.key) {
      protectionSyncBusy = true; box.dataset.busy = '1';
      fetch(PW.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: box.dataset.key, quantity: 0 }) }).then((r) => { if (r.ok) return refreshProtection(); }).catch(() => {}).finally(() => { protectionSyncBusy = false; delete box.dataset.busy; });
    }
  }
  document.addEventListener('change', (e) => {
    const t = e.target.closest('[data-protection-toggle]'); if (!t || !window.PW) return;
    const box = t.closest('[data-protection]'); const variant = parseInt(box.dataset.variant, 10);
    box.dataset.busy = '1'; box.classList.add('is-loading');
    const done = () => PW.refreshCart(false).finally(() => { delete box.dataset.busy; });
    if (t.checked) {
      try { localStorage.removeItem('pw_sp_off'); } catch (err) {}
      PW.addToCart([{ id: variant, quantity: 1 }]).then(done).catch(done);
    } else {
      try { localStorage.setItem('pw_sp_off', '1'); } catch (err) {}
      fetch(PW.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: box.dataset.key, quantity: 0 }) }).then(done).catch(done);
    }
  });
  function watchDrawer() {
    const drawer = document.getElementById('CartDrawer'); if (!drawer || drawer.dataset.spWatch) return; drawer.dataset.spWatch = '1';
    new MutationObserver(() => { syncProtection(); }).observe(drawer, { childList: true, subtree: true });
    syncProtection();
  }

  function initThumbs() {
    document.querySelectorAll('.gallery__thumb--rich').forEach((t) => {
      if (t.dataset.plus) return; t.dataset.plus = '1';
      t.addEventListener('click', () => { if (window.PW && window.PW.gallerySelect) window.PW.gallerySelect(t.dataset.mediaId); });
    });
  }

  /* ---------- Trustpilot compact: rustig roterende echte reviews ---------- */
  function initTpMini() {
    document.querySelectorAll('[data-tp-mini]').forEach((box) => {
      if (box.dataset.init) return; box.dataset.init = '1';
      const qs = Array.from(box.querySelectorAll('.tp-mini__quote')); if (qs.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let i = 0, paused = false;
      box.addEventListener('mouseenter', () => { paused = true; }); box.addEventListener('mouseleave', () => { paused = false; });
      setInterval(() => {
        if (paused || document.hidden) return;
        qs[i].classList.remove('is-active'); qs[i].setAttribute('aria-hidden', 'true');
        i = (i + 1) % qs.length;
        qs[i].classList.add('is-active'); qs[i].removeAttribute('aria-hidden');
      }, 6000);
    });
  }
  function boot() { initTpMini(); initThumbs(); watchDrawer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* ---------- Lux Motion: scroll-progress, header-puls, blur-reveal, spotlight, klik-ring ---------- */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var html = document.documentElement;
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function () {
    if (reduce) return;
    /* scroll progress + header state */
    var bar = document.createElement('div'); bar.className = 'lux-progress'; bar.setAttribute('aria-hidden', 'true'); document.body.appendChild(bar);
    var ticking = false;
    function onScroll() {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var max = html.scrollHeight - window.innerHeight; var p = max > 0 ? Math.min(1, window.scrollY / max) : 0;
        bar.style.setProperty('--lux-p', p.toFixed(4));
        html.classList.toggle('lux-scrolled', window.scrollY > 24);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    /* reveal for elements without data-reveal */
    var sel = '.product-card, .collection-card, .story-card, .tp__card, .card, .faq__item, .usp, .footer__grid > *, .section-head, .h2, .h3, .cart-line';
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: .08 }) : null;
    function scan(root) {
      (root || document).querySelectorAll(sel).forEach(function (el) {
        if (el.dataset.luxDone || el.hasAttribute('data-reveal') || el.closest('[data-reveal], [data-stagger], .drawer, .mobile-menu, .header')) { el.dataset.luxDone = '1'; return; }
        el.dataset.luxDone = '1';
        var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.setProperty('--lux-d', Math.min(sib, 8) * 70 + 'ms');
        el.classList.add('lux-reveal');
        if (io) io.observe(el); else el.classList.add('is-in');
      });
      (root || document).querySelectorAll('.section-head').forEach(function (h) { if (io && !h.dataset.luxHead) { h.dataset.luxHead = '1'; io.observe(h); } });
    }
    scan();
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
    new MutationObserver(function (m) { m.forEach(function (x) { x.addedNodes.forEach(function (n) { if (n.nodeType === 1 && !n.closest('.drawer, .mobile-menu')) scan(n); }); }); }).observe(document.body, { childList: true, subtree: true });
    /* spotlight coordinates on cards and buttons */
    if (fine) {
      document.addEventListener('pointermove', function (e) {
        var t = e.target.closest && e.target.closest('.product-card, .card--hover, .collection-card, .story-card, .btn--gold, .btn--noir'); if (!t) return;
        var r = t.getBoundingClientRect();
        t.style.setProperty('--lux-x', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        t.style.setProperty('--lux-y', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      }, { passive: true });
    }
    /* click ring on buttons */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.btn'); if (!b) return;
      var r = b.getBoundingClientRect(); var ring = document.createElement('span'); ring.className = 'lux-ring';
      ring.style.left = (e.clientX - r.left) + 'px'; ring.style.top = (e.clientY - r.top) + 'px';
      b.appendChild(ring); setTimeout(function () { ring.remove(); }, 650);
    });
  });
})();

/* ---------- PDP: grote prijs + sticky volgen abonnement/eenmalig ---------- */
(function () {
  'use strict';
  function sync() {
    var root = document.querySelector('[data-product]'); if (!root) return;
    var price = root.querySelector('.product__price-row--buy [data-price]'); var cmp = root.querySelector('.product__price-row--buy [data-compare]');
    var sp = root.querySelector('[data-sticky-price]'); var sc = root.querySelector('[data-sticky-compare]');
    var sel = window.PWSubscriptions && window.PWSubscriptions.selector(root);
    var a = window.PWSubscriptions && window.PWSubscriptions.allocation(root);
    var per = root.querySelector('.product__per');
    root.classList.toggle('is-subscribe', !!a);
    if (a) {
      if (price) { if (!price.dataset.orig) price.dataset.orig = price.textContent; price.textContent = a.per_delivery_text; }
      if (cmp) { cmp.textContent = a.compare_text; cmp.classList.toggle('hidden', a.compare_price <= a.price); }
      if (!per && price) { per = document.createElement('span'); per.className = 'product__per'; price.parentNode.insertBefore(per, cmp ? cmp.nextSibling : null); }
      if (per) { per.textContent = sel ? sel.dataset.priceLabel : ''; per.hidden = false; }
      if (sp) sp.textContent = a.per_delivery_text; if (sc) { sc.textContent = a.compare_text; sc.hidden = a.compare_price <= a.price; }
    } else {
      var ot = root.querySelector('[data-pw-onetime-price]'); if (price && ot && ot.textContent.trim()) price.textContent = ot.textContent.trim();
      if (cmp && sel) { cmp.classList.add('hidden'); }
      if (sp && price) sp.textContent = price.textContent;
      if (per) per.hidden = true;
      if (sc && cmp) { sc.textContent = cmp.textContent; sc.hidden = cmp.classList.contains('hidden'); }
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-product]'); if (!root) return;
    root.addEventListener('pw:purchase-change', function () { setTimeout(sync, 0); });
    root.addEventListener('change', function () { setTimeout(sync, 30); });
    setTimeout(sync, 300);
  });
})();
